import type { Node, WorkflowElement } from '../../model';
import { convertNodesToQueue } from './convert-nodes-to-queue';

const transformParticipantToDocumentQueue = (data: any) => ({
  email: data.user?.email || data.email,
  signMethod: data.signMethod,
  identityProvider: data.identityProvider,
  canEdit: data.canEdit,
  locale: data.locale,
  phoneNumber: data.authPhone || data.user?.authPhone || data.phoneNumber,
  message: data.invitation?.message,
  _path: data.id,
});

const transformNodeToDocumentQueueParts = (node: Node<any>): [any, any] => {
  const group: any[] = [];
  const queue = node.parameters.participants.map((p: any) => {
    if (p.type === 'participant-user') {
      return transformParticipantToDocumentQueue(p.parameters);
    }

    if (p.type === 'participant-group') {
      const users = p.parameters.participants.map((u: WorkflowElement) => ({
        documentUsersId: u.id,
        ...transformParticipantToDocumentQueue(u.parameters),
        _path: `${p.id}.participants.${u.id}`,
      }));

      const { name } = p.parameters;

      group.push({
        id: p.isNew ? undefined : p.id,
        name,
        requiredApprovals: p.parameters.requiredApprovals,
        users,
      });
      return users;
    }

    throw new Error(
      `transformNodeToStepParts: Unknown participant type: ${p.type}`,
    );
  });

  return [queue.flat(), group];
};

/**
 * This function converts a Workflow model to a document queue model.
 *
 * @param {Node} nodes - The nodes of the workflow. This node must be in the correct order.
 * @returns {[DocumentQueue, BaseQueueGroup[]]} - The converted queue and group objects.
 */
export const convertNodesToDocumentQueue = convertNodesToQueue(
  transformNodeToDocumentQueueParts,
);
